import { Text } from "@growtherapy/sprout-ui";
import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import { ModifiedToastAria, Toast, ToastVariant } from "../../toasts";

const ConsentDeclinedToastText = {
  CONSENT_DECLINED: "Consent declined.",
  VISITOR_DECLINED_CONSENT:
    "We've let your provider know and saved your consent setting.",
  OTHER_VISITOR_DECLINED_CONSENT:
    "Another participant has declined to consent to transcription. The session will not be recorded.",
};

export function ConsentDeclinedToast({
  contentProps,
  descriptionProps,
  titleProps,
  visitorDeclinedConsent,
  ...toastAriaProps
}: ModifiedToastAria & { visitorDeclinedConsent: boolean }) {
  return (
    <Toast
      {...toastAriaProps}
      aria-live="assertive"
      variant={ToastVariant.Info}
      icon={faCircleMinus}
    >
      <div {...contentProps}>
        <span className="sr-only" {...titleProps}>
          {ConsentDeclinedToastText.CONSENT_DECLINED}
        </span>
        <Text as="span" {...descriptionProps}>
          {visitorDeclinedConsent
            ? ConsentDeclinedToastText.VISITOR_DECLINED_CONSENT
            : ConsentDeclinedToastText.OTHER_VISITOR_DECLINED_CONSENT}
        </Text>
      </div>
    </Toast>
  );
}
